// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';

import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Grid from 'react-bootstrap/lib/Grid';
import Button from 'react-bootstrap/lib/Button';

import s from './ListPlaceStep1.css';
import bt from '../../components/commonStyle.css';

import Avatar from '../Avatar';
import update from './update';

import messages from '../../locale/messages';

import Logo from '../Logo';
import logoPrimary from '/public/eslipin-logo-secundario-blue.png';
import personajeCelebrando from '/public/SiteImages/personaje-celebrando.svg';
import eslipinSmile from '/public/SiteImages/variante-logo-relajado.svg';
import Link from '../Link/Link';
class ListIntro extends Component {

    static propTypes = {
        initialValues: PropTypes.object,
        hostDisplayName: PropTypes.string,
        guestDisplayName: PropTypes.string,
        nextPage: PropTypes.any,
        hostPicture: PropTypes.string,
        guestPicture: PropTypes.string,
        userData: PropTypes.shape({
            firstName: PropTypes.string.isRequired
        }).isRequired
    };

    static defaultProps = {
        userData: {
            firstName: ''
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            roomType: [],
            personCapacity: []
        }
    }

    UNSAFE_componentWillMount() {
        const { listingFields } = this.props;
        if (listingFields != undefined) {
            this.setState({
                roomType: listingFields.roomType,
                personCapacity: listingFields.personCapacity
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { listingFields } = nextProps;
        if (listingFields != undefined) {
            this.setState({
                roomType: listingFields.roomType,
                personCapacity: listingFields.personCapacity
            });
        }
    }


    render() {
        const { nextPage, userData, hostPicture, hostDisplayName, guestDisplayName } = this.props;
        return (
            <div className={s.eslipinBgIntro}>
                <Link to={'/'}>
                    <img src={logoPrimary} className={s.eslipinLogoTop} alt="Eslipin" />
                    <p className={s.labelLogo}>Alójate seguro, sin complicaciones</p>
                </Link>
                {/* <Logo link={"/"} className={cx(s.eslipinLogoTop)} /> */}
                <div className={s.introCardWrapper}>
                    <div className={s.introCard}>
                        <div className={s.introIllustrations}>
                            <img src={personajeCelebrando} className={s.personajeCelebrando} alt="" />
                            <img src={eslipinSmile} className={s.eslipinSmileIcon} alt="" />
                        </div>
                        <h2 className={s.introGreeting}>
                            <FormattedMessage {...messages.hi} />, <span className={s.userNameColor}>{userData.firstName}!</span>
                        </h2>
                        <p className={s.introSubTitle}><FormattedMessage {...messages.letYouGetReady} /></p>
                        <Button className={cx(bt.btnPrimary, bt.btnLarge, s.letsStartBtn)} onClick={() => nextPage('room')}>
                            <FormattedMessage {...messages.letsStart} />
                        </Button>
                    </div>
                </div>
            </div>
        )
    }
}

ListIntro = reduxForm({
    form: 'ListPlaceStep1', // a unique name for this form
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    onSubmit: update
})(ListIntro);

const mapState = (state) => ({
    userData: state.account.data,
    listingFields: state.listingFields.data
});

const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(ListIntro)));